<template>
  <div class="aigcItemNumBox" :style="getMainColorBg">
    {{ index }}
  </div>
</template>
<script>
export default {
  name: 'aigcItemNum',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    mainColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    getMainColor() {
      return this.mainColor ? `color:${this.mainColor}` : 'color:#00c4c9'
    },
    getMainColorBg() {
      return this.mainColor ? `background:${this.mainColor}` : 'background:#00c4c9'
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {},
}
</script>
<style scoped lang="less">
.aigcItemNumBox {
  position: absolute !important;
  top: 5px;
  left: 5px;
  z-index: 1;
  min-width: 17px;
  height: 18px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  padding: 6px 6px 5px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 196, 201, 0.8);
}
</style>